module.exports = __webpack_public_path__ + "img/pro1.e57d1673.png";